<!-- eslint-disable vue/no-dupe-v-else-if -->
<template>
  <div id="app">
    {{checkRoleAdmin.value}}
    <nav-bar :prop-user="user"/>

    <!-- Academic -->
    <aside-menu  :menu="menu"/>

    <router-view v-if="subIsActive(['/login', '/change-password', '/resetpassword'])"/>
    <div v-else class="transition-position duration-1000" :class="isAsideMobileExpanded ? 'lg:pl-0' : 'lg:pl-64'">
      <div class="pt-14">
        <div class="transition-position duration-1000">
          <div class="">
            <router-view/>
          </div>
          <footer-bar/>
        </div>
        <vue-progress-bar />
      <!-- <footer-bar/> -->
      <overlay v-show="isAsideLgActive" z-index="z-30" @overlay-click="overlayClick" />
      </div>
    </div>
  </div>
</template>

<script>
  // @ is an alias to /src
  /* eslint-disable */
  import axios from 'axios'
  import { computed, ref, watchEffect , onMounted} from 'vue'
  import { useStore } from 'vuex'
  import { useI18n } from 'vue-i18n';
  import menu from '@/menuDoc.js'
  import { useRouter } from 'vue-router'
  import menuUser from '@/menuParentAndStudent.js'
  import menuEmployee from '@/menuEmployee.js'
  import menuFinanceAdm from '@/menuFinanceAdm.js'
  import menuFinance from '@/menuFinance.js'
  import menuTeacher from '@/menuTeacher.js'
  import menuComboard from '@/menuComboard.js'
  import menuModule from '@/menuModule.js'
  import NavBar from '@/components/NavBar'
  import AsideMenu from '@/components/AsideMenu'
  import FooterBar from '@/components/FooterBar'
  import Overlay from '@/components/Overlay'
  import '@tailwindcss/forms/dist/forms.min.css'
  import CryptoJS from 'crypto-js'

  export default {
    name: 'Home',
    components: {
      Overlay,
      FooterBar,
      AsideMenu,
      NavBar,
    },
    methods: {
      subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];
        return paths.some((path) => {
          return this.$route.path.indexOf(path) === 0; // current path starts with this path string
        });
      },
    },
    setup () {
      const router = useRouter()
      const { t } = useI18n({useScope: 'global'});
      const store = useStore()
      const isAsideMobileExpanded = computed(() => store.state.isAsideMobileExpanded)
      const mainmenu = ref(localStorage.getItem('menu'))
      const academic = true
      const finance = false
      const checkRoleAdmin = ref(false)
      const user = ref({})
      const parentRole = localStorage.getItem('loginAs') === 'parent'
      const studentRole = localStorage.getItem('loginAs') === 'student'
      // store.state.auth.user = null
      if (store.state.auth.user) {
        store.commit('user', {
          name: store.state.auth.user.name,
          email: store.state.auth.user.email,
          avatar: 'https://avatars.dicebear.com/api/avataaars/example.svg?options[top][]=shortHair&options[accessoriesChance]=93'
        })
        user.value = store.state.auth.user
      }

      const isAsideLgActive = computed(() => store.state.isAsideLgActive)

      const overlayClick = () => {
        store.dispatch('asideLgToggle', false)
      }

      // const frontPage = store.dispatch('logout') || store.dispatch('logoutStudent') || store.dispatch('logoutParent')
      const frontPage = localStorage.getItem('token')
      const user_id = localStorage.getItem('user_id')
      const userRole = localStorage.getItem('roles')
      const checkUser = ref(false)
      const checkUserFinance = ref(false)
      const checkUserTeacher = ref(false)
      const checkUserYayasan = ref(false)
      const userCheck = async () => {
        if(user_id !== null){
          const decryptedMessage = CryptoJS.AES.decrypt(localStorage.getItem('role'), 'amatra1609').toString(CryptoJS.enc.Utf8)
          if (decryptedMessage === 'ROLE_TEACHER') {
            checkUserTeacher.value = true
          }
          if (decryptedMessage === 'ROLE_ADMIN_FINANCE') {
            checkUser.value = true
          }
          if (decryptedMessage === 'ROLE_FINANCE') {
            checkUserFinance.value = true
          }
          if (decryptedMessage === 'ROLE_FOUNDATION') {
            checkUserYayasan.value = true
          }

          const myArray = decryptedMessage.split(',')
          for (let i = 0; i < myArray.length; i++) {
            if (myArray[i] === 'ROLE_TEACHER') {
              checkUserTeacher.value = true
            }
            if (myArray[i] === 'ROLE_ADMIN_FINANCE') {
              checkUser.value = true
            }
            if (myArray[i] === 'ROLE_FINANCE') {
              checkUserFinance.value = true
            }
            if (myArray[i] === 'ROLE_FOUNDATION') {
              checkUserYayasan.value = true
            }
          }
        }
        // console.log('checkUserFinance', checkUserFinance)
        // console.log('mainmenu', mainmenu)
      }

      const limitLogin = async() => {
        const url = 'check-limit-login'
        const method = 'POST'

        const params = {
          user_id: localStorage.getItem('user_id'),
          loginAS: localStorage.getItem('loginAs')
        }

        await axios({
              method,
              url,
              params
            })
            .then(response => {

              if(response.data.olddate < response.data.newdate){
                router.push(response.data.status)
                localStorage.clear()
              }
              // console.log('check old date login', response.data.olddate)
              // console.log('check date sekarang', response.data.newdate)
            })
            .catch(error => {
              let status = '/login';
              if(localStorage.getItem('loginAs') == 'student'){
                  status = '/login-student';
              }
              if(localStorage.getItem('loginAs') == 'parent'){
                  status = '/login-parent';
              }

              router.push(status)
              localStorage.clear()
              // console.log('error.response', error.response)
            })
      }

      onMounted(() => {
        // userCheck()
        // limitLogin()

        if(localStorage.getItem('loginAs') === 'administrator') {
          checkRoleAdmin.value === true
        }
        if(localStorage.getItem('loginAs') === 'student' || localStorage.getItem('loginAs') === 'parent') {
          checkRoleAdmin.value === false
        }

      })
      watchEffect(() => {
        // limitLogin()
        // user.value = store.state.auth.user
        if(localStorage.getItem('loginAs') === 'administrator') {
          checkRoleAdmin.value = true
        }
        if(localStorage.getItem('loginAs') === 'student' || localStorage.getItem('loginAs') === 'parent') {
          checkRoleAdmin.value = false
        }
      })

      return {
        router,
        userRole,
        user_id,
        userCheck,
        checkUser,
        checkUserTeacher,
        checkUserFinance,
        checkUserYayasan,
        menu,
        menuUser,
        checkRoleAdmin,
        mainmenu,
        academic,
        finance,
        menuEmployee,
        menuFinanceAdm,
        menuTeacher,
        menuFinance,
        menuComboard,
        menuModule,
        isAsideLgActive,
        isAsideMobileExpanded,
        overlayClick,
        user,
        frontPage,
        t,
        parentRole,
        studentRole
      }
    },
    mounted () {
      //  [App.vue specific] When App.vue is finish loading finish the progress bar
      this.$Progress.finish()
    },
    created () {
      //  [App.vue specific] When App.vue is first loaded start the progress bar
      this.$Progress.start()
      //  hook the progress bar to start before we move router-view
      // this.$router.beforeEach((to, from, next) => {
      //   //  does the page we want to go to have a meta.progress object
      //   if (to.meta.progress !== undefined) {
      //     const meta = to.meta.progress
      //     // parse meta tags
      //     this.$Progress.parseMeta(meta)
      //   }
      //   //  start the progress bar
      //   this.$Progress.start()
      //   //  continue to next page
      //   next()
      // })
      //  hook the progress bar to finish after we've finished moving router-view
      this.$router.afterEach((to, from) => {
        //  finish the progress bar
        this.$Progress.finish()
      })
    }
  }
</script>
